export default __webpack_public_path__ + "static/media/Kawasaki z750.19f5e2b3.jpg";